import React from 'react';
import { Link } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';

interface Props {
  isExternalLink: boolean;
  label: string;
  linkTo: string;
}

const BottomLinksMobile: React.FC<Props> = ({
  isExternalLink,
  label,
  linkTo,
  ...rest
}) =>
  !isExternalLink ? (
    <Link
      as={GatsbyLink}
      to={linkTo}
      minW="29%"
      my={300}
      flexGrow={1}
      color="brandNavy.200"
      textAlign="center"
      letterSpacing="0.15em"
      _hover={{ color: 'primary.500' }}
      _active={{ color: 'primary.300' }}
      size={300}
      fontWeight="bodyBold"
      textTransform="uppercase"
      {...rest}
    >
      {label}
    </Link>
  ) : (
    <Link
      href={linkTo}
      minW="29%"
      my={300}
      flexGrow={1}
      color="brandNavy.200"
      textAlign="center"
      letterSpacing="0.15em"
      _hover={{ color: 'primary.500' }}
      _active={{ color: 'primary.300' }}
      size={300}
      fontWeight="bodyBold"
      textTransform="uppercase"
      {...rest}
    >
      {label}
    </Link>
  );

export default BottomLinksMobile;
